"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ApiAccountType;
(function (ApiAccountType) {
    ApiAccountType["regular"] = "REGULAR";
})(ApiAccountType = exports.ApiAccountType || (exports.ApiAccountType = {}));
//# sourceMappingURL=ApiAccountType.js.map